import {
  Phone,
  ThumbsUp,
  Calendar,
  FileText,
  Trophy,
  XCircle,
  LucideIcon,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import type { DealStage } from '@/services/api'

interface StageConfig {
  label: string
  color: string
  darkColor: string
  icon: LucideIcon
  order: number
}

export const DEAL_STAGE_CONFIG: Record<DealStage, StageConfig> = {
  contacted: {
    label: 'Contacted',
    color: 'bg-primary/10 text-primary border-primary/20',
    darkColor: '',
    icon: Phone,
    order: 1,
  },
  interested: {
    label: 'Interested',
    color: 'bg-chart-2/10 text-chart-2 border-chart-2/20',
    darkColor: '',
    icon: ThumbsUp,
    order: 2,
  },
  meeting_scheduled: {
    label: 'Meeting Scheduled',
    color: 'bg-chart-5/10 text-chart-5 border-chart-5/20',
    darkColor: '',
    icon: Calendar,
    order: 3,
  },
  proposal: {
    label: 'Proposal',
    color: 'bg-chart-4/10 text-chart-4 border-chart-4/20',
    darkColor: '',
    icon: FileText,
    order: 4,
  },
  won: {
    label: 'Won',
    color: 'bg-chart-1/10 text-chart-1 border-chart-1/20',
    darkColor: '',
    icon: Trophy,
    order: 5,
  },
  lost: {
    label: 'Lost',
    color: 'bg-destructive/10 text-destructive border-destructive/20',
    darkColor: '',
    icon: XCircle,
    order: 6,
  },
}

export const DEAL_STAGES: DealStage[] = [
  'contacted',
  'interested',
  'meeting_scheduled',
  'proposal',
  'won',
  'lost',
]

export const ACTIVE_DEAL_STAGES: DealStage[] = [
  'contacted',
  'interested',
  'meeting_scheduled',
  'proposal',
]

interface DealStageBadgeProps {
  stage: DealStage
  showIcon?: boolean
  size?: 'sm' | 'md'
  className?: string
}

export function DealStageBadge({
  stage,
  showIcon = true,
  size = 'md',
  className,
}: DealStageBadgeProps) {
  const config = DEAL_STAGE_CONFIG[stage]
  const Icon = config.icon

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md border font-medium',
        config.color,
        config.darkColor,
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs',
        className
      )}
    >
      {showIcon && (
        <Icon className={cn(size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
      )}
      {config.label}
    </span>
  )
}
